import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import TooltipContainer from './tooltip_container';

const CLASS_NAME = 'tooltip-content-wrapper';

const TooltipContentWrapper = props => {
  const [isOpen, setIsOpen] = useState(false);

  const parentRef = props.withTooltip ? useRef(null) : null;

  const onFocus = () => {
    if (props.withTooltip) {
      setIsOpen(true);
    }
  };

  const onBlur = () => {
    if (props.withTooltip) {
      setIsOpen(false);
    }
  };

  const {
    className,
    containerHeight,
    containerWidth,
    content,
    defaultCell,
    onClick,
    paddingHorizontalRemoval,
    paddingVerticalRemoval,
    positionHorizontal,
    positionVertical,
    tooltipClassName,
    tooltipContent,
    withArrow,
    withLink,
    withTooltip,
  } = props;

  const tooltip = withTooltip && (
    <TooltipContainer
      className={tooltipClassName}
      containerHeight={containerHeight}
      containerWidth={containerWidth}
      isOpen={isOpen}
      paddingHorizontalRemoval={paddingHorizontalRemoval}
      paddingVerticalRemoval={paddingVerticalRemoval}
      parentRef={parentRef}
      positionHorizontal={positionHorizontal}
      positionVertical={positionVertical}
      withArrow={withArrow}
    >
      {tooltipContent}
    </TooltipContainer>
  );

  const contentClass = classnames('tooltip-container', className, {
    '-with-arrows': withArrow,
  });

  if (withLink) {
    return (
      <div className={contentClass}>
        <div
          className={classnames(CLASS_NAME, `${CLASS_NAME}--link`, {
            'default-cell': defaultCell,
          })}
          onClick={onClick}
          onPointerEnter={onFocus}
          onPointerLeave={onBlur}
          role="presentation"
          ref={parentRef}
        >
          {content}
        </div>
        {tooltip}
      </div>
    );
  }

  return (
    <div className={contentClass}>
      <div
        className={classnames(CLASS_NAME, { 'default-cell': defaultCell })}
        onPointerEnter={onFocus}
        onPointerLeave={onBlur}
        ref={parentRef}
      >
        {content}
        {tooltip}
      </div>
    </div>
  );
};

TooltipContentWrapper.propTypes = {
  className: PropTypes.string,
  containerHeight: PropTypes.number,
  containerWidth: PropTypes.number,
  content: PropTypes.node,
  defaultCell: PropTypes.bool,
  nextReservation: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  onClick: PropTypes.func,
  paddingHorizontalRemoval: PropTypes.number,
  paddingVerticalRemoval: PropTypes.number,
  positionHorizontal: PropTypes.string,
  positionVertical: PropTypes.string,
  tooltipClassName: PropTypes.string,
  tooltipContent: PropTypes.node,
  withArrow: PropTypes.bool,
  withLink: PropTypes.bool,
  withTooltip: PropTypes.bool,
};

export default TooltipContentWrapper;
